import FingerprintJS from '@fingerprintjs/fingerprintjs'

export async function getDeviceId() {
  const fp = await FingerprintJS.load()
  const result = await fp.get()
  const deviceId = result.visitorId // 这是一个 32 位的哈希字符串
  logger.debug('设备唯一指纹:', deviceId)
  return deviceId
}

/**
 * 判断当前设备是否为 Apple 设备 (iPhone, iPad, iPod 或 Mac)
 * @returns {boolean}
 */
export const isAppleDevice = () => {
  if (typeof window === 'undefined') return false

  const ua = window.navigator.userAgent.toLowerCase()
  // 1. 基础正则判断：iPhone, iPod, iPad (旧版)
  const isIOS = /iphone|ipad|ipod/.test(ua)
  // 2. Mac 电脑识别
  const isMac = /macintosh|mac os x/.test(ua)

  // 3. 针对新版 iPadOS 的特殊识别
  // 现代 iPad 默认请求桌面网站，UA 看起来像 Mac，但支持多点触控
  const isIPadOS = navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1

  return isIOS || isMac || isIPadOS
}
